import {IconProp} from "@fortawesome/fontawesome-svg-core"
import {faPlay, faRedo, faTimes} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {AuctionHistory, AuctionHistoryEntry} from "domain-models"
import {date, relativeNonUtc} from "filters"
import _ from 'lodash'
import React from "react"
import Trans from '../../../../components/Trans'

type ProtocolProps = {
  history: AuctionHistory
}

type EntrySettings = {
  [label: string]: {
    icon: IconProp
    color: string
  }
}

class Protocol extends React.Component<ProtocolProps> {
  private entrySettings: EntrySettings = {
    'Eine neue Auktionsrunde wurde gestartet': {
      icon: faRedo,
      color: 'text-blue-800'
    },
    'abgebrochen': {
      icon: faTimes,
      color: 'text-red-800'
    },
    'Auktion gescheitert': {
      icon: faTimes,
      color: 'text-red-800'
    },
    'Auktion wurde gestartet': {
      icon: faPlay,
      color: 'text-green-800'
    },
  }

  render() {
    return (
      <div className="w-full flex flex-row flex-wrap mt-6 md:mt-0">
        <span className='font-semibold text-gray-700 w-full'><Trans>Protokoll</Trans></span>

        <div className="flex flex-col">
          <div className="border-t border-gray-300 my-1"/>

          {_.map(this.props.history, (entry: AuctionHistoryEntry) => (
            <div className="flex flex-row text-sm mt-2" key={entry.Id}>
              <Icon icon={this.entrySettings[entry.Action].icon} className={this.entrySettings[entry.Action].color}/>
              <div className="flex flex-col full-width ml-2">
                <div className="flex flex-row justify-between">
                  <div className="text-gray-800">
                    <span><Trans>{entry.Action}</Trans></span>
                  </div>
                  <div className="text-gray-600" />
                </div>
                <div className="text-gray-600"> {relativeNonUtc(entry.InsertedOn)} am {date(entry.InsertedOn)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default Protocol
